import React from 'react';
import {
  AccountabilitySVG,
  TransparencySVG,
  SustainabilitySourceSVG,
  QualityNonNegotiableSVG,
  PartnershipSVG,
  SimplicitySVG,
  ContinuousImprovementSVG,
  RespectSVG
} from './SVGs/ValuesSVGs';

const ValuesSection = () => {
  const values = [
    { 
      icon: <AccountabilitySVG />,
      title: 'Accountability Over Convenience', 
      desc: 'We own outcomes. If something goes wrong, we fix it and improve the system so it does not happen again.',
      color: '#0f3b5e'
    },
    { 
      icon: <TransparencySVG />,
      title: 'Transparency From Day One', 
      desc: 'Clear processes, documented decisions, measurable outcomes. No black boxes. No hidden steps.',
      color: '#0f3b5e'
    },
    { 
      icon: <SustainabilitySourceSVG />,
      title: 'Sustainability at the Source', 
      desc: 'Reduce emissions where they are created. Simplify supply chains, remove waste, improve efficiency.',
      color: '#22c55e'
    },
    { 
      icon: <QualityNonNegotiableSVG />,
      title: 'Quality Is Non-Negotiable', 
      desc: 'Embedded engineering & QC — meet and exceed European expectations consistently, not occasionally.',
      color: '#0f3b5e'
    },
    { 
      icon: <PartnershipSVG />,
      title: 'Partnership Over Transactions', 
      desc: 'Long-term collaboration, shared growth, continuous improvement. Success is measured over years, not orders.',
      color: '#0f3b5e'
    },
    { 
      icon: <SimplicitySVG />,
      title: 'Simplicity Creates Impact', 
      desc: 'Remove unnecessary steps, intermediaries, and duplication to reduce cost, risk, and carbon emissions.',
      color: '#0f3b5e'
    },
    { 
      icon: <ContinuousImprovementSVG />,
      title: 'Continuous Improvement Always', 
      desc: 'Data-driven KPIs and real-world outcomes. Every project is an opportunity to improve quality, reduce waste, and lower environmental impact.',
      color: '#0f3b5e'
    },
    { 
      icon: <RespectSVG />,
      title: 'Respect for People & Ecosystems', 
      desc: 'Ethical practices, fair collaboration, and responsible growth. Manufacturing affects people, communities, and environments.',
      color: '#0f3b5e'
    },
  ];

  return (
    <section id="values" className="values-section">
      <div className="container">
        <div className="section-header">
          <span className="label">our values</span>
          <h2>Accountability Over Convenience</h2>
          <p>Eight principles that guide how we operate — and how we grow. They define how we earn trust, deliver quality, and contribute to a more transparent, responsible, and lower-carbon global manufacturing ecosystem.</p>
        </div>
        
        <div className="values-grid">
          {values.map((v, idx) => (
            <div key={idx} className="value-card">
              <div className="value-icon" style={{ borderColor: v.color }}>
                {v.icon}
              </div>
              <h4 style={{ color: v.color }}>{v.title}</h4>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
        
        <div className="values-footer">
          <p>
            "These values guide how ProcureForEU operates today — and how we will grow tomorrow. 
            They define how we earn trust, deliver quality, and contribute to a more transparent, 
            responsible, and lower-carbon global manufacturing ecosystem."
          </p>
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;